module.exports = __webpack_public_path__ + "static/media/high-right-2.43a9647e.png";